import axios from "axios";
import api from "./api";

const converStringParams = (params) => {
  return Object.entries(params)
    .filter(([_, value]) => {
      return value !== null && value !== undefined;
    })
    .map(([key, value]) => {
      return key + "=" + value;
    })
    .join("&");
}

export function getConfigs() {
  return api
    .apiCall("GET", `/v1/products/zuttoride/configs`)
    .then((res) => res)
    .catch((err) => err.response);
}

export function getPackage({ bikeType, period }) {
  return api
    .apiCall(
      "GET",
      `/v1/products/zuttoride/packages?vehicleType=${bikeType}&yearsOfInsurance=${period}`
    )
    .then((res) => res)
    .catch((err) => err.response)
}

export function getProductLines(manufactureId) {
  return api
    .apiCall(
      "GET",
      `/v1/products/zuttoride/models/${manufactureId}`
    )
    .then((res) => res)
    .catch((err) => err.response);
}

export function checkRedeemCode(data) {
  return api
    .apiCall("POST", `/v1/products/zuttoride/redeem-code/verify`, data)
    .then((res) => res)
    .catch((err) => err.response);
}

export function getCommission(data) {
  return api
    .apiCall("POST", `/v1/products/zuttoride/commission`, data)
    .then((res) => res)
    .catch((err) => err.response);
}

export function createInsu(data) {
  return api
    .apiCall("POST", `/v1/products/zuttoride/orders`, data)
    .then((res) => res)
    .catch((err) => err.response);
}

export function scanImage(data) {
  return api
    .apiCallCoreFormData("POST", `/api/v1/utility/ocr/scan`, data)
    .then((res) => res)
    .catch((err) => err.response);
}

export function uploadImg(data) {
  return api
    .apiCallFormData("POST", `/v1/products/upload/cavet`, data)
    .then((res) => res)
    .catch((err) => err.response);
}

export function scanImageV2(data, headerParam) {
  return api
    .apiCall("POST", `/v1/ocr/vehicle`, data, headerParam)
    .then((res) => res)
    .catch((err) => err.response);
}

export function getBalance(title) {
  return api
    .apiCallCore("GET", `/api/v1/wallet/reward/balance`)
    .then((res) => res)
    .catch((err) => err.response);
}

export function getProductLineByBikeType(productLineId) {
  return api
    .apiCall("GET", `/v1/products/zuttoride/models/${productLineId}/capacity`)
    .then((res) => res)
    .catch((err) => err.response);
}

export function getStime(data, headerParam) {
  return api
    .apiCall('GET', `/v1/products/stime`, data, {
      'Content-Type': 'application/json',
    })
    .then((res) => res)
    .catch((err) => err.response);
}

export function getCollaboratorDetail(headerParam) {
  return api
    .apiCall('GET', `/v1/products/collaborator-detail`, {}, headerParam)
    .then((res) => res)
    .catch((err) => err.response);
}